/** Roll back both Guided Setup entry points without changing the classic Plan editor. */
export const USE_LEGACY_SMB_GUIDED_SETUP = false

export const SMB_GUIDED_GROWTH_DEFAULT = 2
export const SMB_GUIDED_GROWTH_STEP = 0.5
export const SMB_GUIDED_GROWTH_MIN = -20
export const SMB_GUIDED_GROWTH_MAX = 20
